export interface AboutTranslations {
  title: string
  subtitle: string
  stats: {
    yearsExperience: string
    projectsCompleted: string
    happyClients: string
    certifications: string
  }
  certifications: {
    title: string
    list: string[]
  }
}

export const aboutTranslations: Record<string, AboutTranslations> = {
  en: {
    title: "Meet James Carling: Your Dedicated Garden Care Expert",
    subtitle: "After working in gardening for over 15 years, I've recently taken the exciting step of setting up my own business. I'm passionate about keeping gardens beautiful and healthy, and I believe every garden deserves regular care and attention. I take pride in helping property owners and commercial spaces enjoy their outdoor areas without the hassle of maintenance.",
    stats: {
      yearsExperience: "Years Experience",
      projectsCompleted: "Gardens Cared For",
      happyClients: "Happy Clients",
      certifications: "Certifications"
    },
    certifications: {
      title: "Professional Certifications",
      list: [
        "NPTC Certificate",
        "Safe Handling & Application of Pesticides (PA1)",
        "Safe Application of Pesticide Using Pedestrian Hand Held Equipment (PA6)"
      ]
    }
  },
  cy: {
    title: "Helo, fi yw James Carling, eich garddwr lleol",
    subtitle: "Ar ôl gweithio mewn garddio am dros 15 mlynedd, rwyf wedi cymryd y cam cyffrous o sefydlu fy mhriodas fy hun yn ddiweddar. Rwy'n angerddol am gadw gerddoedd yn hardd ac iach, ac rwy'n credu bod pob gardd yn haeddu gofal a sylw rheolaidd. Rwy'n falch o helpu perchnogion eiddo a lleoedd masnachol i fwynhau eu hardaloedd awyr agored heb y trafferth o gynnal a chadw.",
    stats: {
      yearsExperience: "Mlynedd o Brofiad",
      projectsCompleted: "Gerddoedd Wedi'u Gofalu",
      happyClients: "Cleientiaid Hapus",
      certifications: "Ardystiadau"
    },
    certifications: {
      title: "Ardystiadau Proffesiynol",
      list: [
        "Tystysgrif NPTC",
        "Trin a Chymhwyso Plaladdwyr yn Ddiogel (PA1)",
        "Cymhwyso Plaladdwyr yn Ddiogel gan Ddefnyddio Offer Llaw Cerddwyr (PA6)"
      ]
    }
  }
} 